/**
 * Created by fwt on 2019/3/20.
 */
import React, {Component} from "react"
import {Toast, ListView} from 'antd-mobile';
import OrderListItem from "../../../components/OrderListItem";
import {orderList} from "../../../service/orderService";
import {connect} from "react-redux";
import './style.less';
const notOrder = require('../../../common/image/notOrder.png');
const dataError = require('../../../common/image/dataError.png');

let pageIndex = 1;
let businessType = 5;
let TYPE = 0;
let pageSize = 10;
@connect(
    state => ({userInfo: state.userInfo})
)
export default class RunOrder extends Component {
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            data: [],
            total: 0,
            firstLoading: true,
            isLoading: true,
            dataSource,
            notDataLoading:0,
        }
    }

    componentDidMount() {
        this.getOrderList();
    }

    getOrderList() {
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                businessType:businessType,
                status: TYPE,
                pageSize: pageSize,
                pageNum: 1,
            }
        };
        Toast.loading("正在加载", 0);
        orderList(params).then((res) => {
            pageIndex = 1;
            if (res.data.code === '0000') {
                Toast.hide();
                if(res.data.data.list.length > 0){
                    this.setState({
                        data: res.data.data == '' ? [] : res.data.data.list,
                        firstLoading: false,
                        total: res.data.data.total
                    });
                    this._setDataSource(this.state.data);
                    if (pageIndex * pageSize >= this.state.total) {
                        this.setState({
                            isLoading: false,
                        });
                    }
                }else{
                    this.setState({isLoading: false,notDataLoading:1});
                }

            } else {
                Toast.info(res.data.msg,3);
                this.setState({isLoading: false,notDataLoading:2});
            }
        }).catch(function (error) {
            console.log(error);
        });
    };

    //拼接数据
    _setDataSource(dataSource) {
        if (!dataSource) return false;
        this.setState({
            dataSource: this.state.dataSource.cloneWithRows(dataSource),
        });
    };

    //上拉加载
    _onEndReached = () => {
        if (pageIndex * pageSize >= this.state.total) {
            this.setState({
                isLoading: false,
            });
            return false;
        }
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data:{
                businessType:businessType,
                status: TYPE,
                pageSize: pageSize,
                pageNum: ++pageIndex,
            }
        };
        orderList(params).then((res) => {
            if (res.data.code === '0000') {
                const allData = [...this.state.data, ...res.data.data.list];
                this._setDataSource(allData);
                this.setState({
                    data: allData,
                    total: res.data.data.total
                });
            } else{
                Toast.info(res.data.msg,3)
            }
        }).catch(function (error) {
            console.log(error);
        });
    };
    paySuccess(){
        this.getOrderList();
    }
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noMore">
                <img src={notOrder} />
                <p>暂无订单</p>
            </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noMore">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
    render() {
        const _renderRow = (rowData) => {
            return (
                <OrderListItem rowData={rowData} {...this.props}  paySuccess={this.paySuccess.bind(this)} getOrderList={this.getOrderList.bind(this)}/>
            )
        };

        return (
            this.state.data.length > 0 ? (
                <ListView
                    className="withdrawList"
                    ref={el => this.lv = el}
                    dataSource={this.state.dataSource}
                    renderFooter={() => (<div style={{textAlign: 'center'}}>
                        {this.state.isLoading ? '加载中...' : '没有更多'}
                    </div>)}
                    renderRow={_renderRow}
                    style={{
                        height: '100%',
                        overflow: 'auto',
                    }}
                    scrollRenderAheadDistance={300}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={30}
                />
            ) : (this.notData())
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/member/RunOrder/index.js